import { RfqReview } from './types';
import { createAction } from 'typesafe-actions';

export const INIT_REVIEW = 'review/INIT_REVIEW';
export const initReview = createAction(INIT_REVIEW)();

export const UPDATE_REVIEW = 'review/UPDATE_REVIEW';
export const updateReview = createAction(UPDATE_REVIEW)<RfqReview>();

export const UPDATE_REVIEW_RATING = 'review/UPDATE_REVIEW_RATING';
export const updateReviewRating = createAction(UPDATE_REVIEW_RATING)<
  number | undefined
>();
